// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CommentInput Custom Styles */
.comment-input-container {
  width: 100%;
}

.comment-input-editor {
  width: 100%;
}

/* Custom styles for comment input editor - Remove all borders with highest specificity */
.comment-input-container .comment-input-editor .ql-container.ql-snow,
.comment-input-container .comment-input-editor .ql-container,
.comment-input-container .comment-input-editor .ql-editor,
.comment-input-editor .ql-container.ql-snow,
.comment-input-editor .ql-container,
.comment-input-editor .ql-editor {
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

.comment-input-container .comment-input-editor .ql-container.ql-snow,
.comment-input-editor .ql-container.ql-snow {
  font-size: 14px;
  line-height: 20px;
  background: transparent !important;
}

.comment-input-container .comment-input-editor .ql-editor,
.comment-input-editor .ql-editor {
  padding: 0 !important;
  font-size: 14px;
  line-height: 20px;
  color: #1f2937;
  min-height: 20px;
  background: transparent !important;
}

.comment-input-container .comment-input-editor .ql-editor.ql-blank::before,
.comment-input-editor .ql-editor.ql-blank::before {
  color: #6b7280;
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0.07px;
}

.comment-input-container .comment-input-editor .ql-editor:focus,
.comment-input-editor .ql-editor:focus {
  outline: none !important;
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  box-shadow: none !important;
}

/* Custom variant styles */
.comment-input-container .comment-input-custom .ql-container.ql-snow,
.comment-input-container .comment-input-custom .ql-container,
.comment-input-container .comment-input-custom .ql-editor,
.comment-input-custom .ql-container.ql-snow,
.comment-input-custom .ql-container,
.comment-input-custom .ql-editor {
  border: none !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/comment-input.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,yFAAyF;AACzF;;;;;;EAME,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;;;;;;EAME,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,wBAAwB;EACxB,kCAAkC;AACpC","sourcesContent":["/* CommentInput Custom Styles */\n.comment-input-container {\n  width: 100%;\n}\n\n.comment-input-editor {\n  width: 100%;\n}\n\n/* Custom styles for comment input editor - Remove all borders with highest specificity */\n.comment-input-container .comment-input-editor .ql-container.ql-snow,\n.comment-input-container .comment-input-editor .ql-container,\n.comment-input-container .comment-input-editor .ql-editor,\n.comment-input-editor .ql-container.ql-snow,\n.comment-input-editor .ql-container,\n.comment-input-editor .ql-editor {\n  border: none !important;\n  border-width: 0 !important;\n  border-style: none !important;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.comment-input-container .comment-input-editor .ql-container.ql-snow,\n.comment-input-editor .ql-container.ql-snow {\n  font-size: 14px;\n  line-height: 20px;\n  background: transparent !important;\n}\n\n.comment-input-container .comment-input-editor .ql-editor,\n.comment-input-editor .ql-editor {\n  padding: 0 !important;\n  font-size: 14px;\n  line-height: 20px;\n  color: #1f2937;\n  min-height: 20px;\n  background: transparent !important;\n}\n\n.comment-input-container .comment-input-editor .ql-editor.ql-blank::before,\n.comment-input-editor .ql-editor.ql-blank::before {\n  color: #6b7280;\n  font-style: normal;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n  letter-spacing: 0.07px;\n}\n\n.comment-input-container .comment-input-editor .ql-editor:focus,\n.comment-input-editor .ql-editor:focus {\n  outline: none !important;\n  border: none !important;\n  border-width: 0 !important;\n  border-style: none !important;\n  box-shadow: none !important;\n}\n\n/* Custom variant styles */\n.comment-input-container .comment-input-custom .ql-container.ql-snow,\n.comment-input-container .comment-input-custom .ql-container,\n.comment-input-container .comment-input-custom .ql-editor,\n.comment-input-custom .ql-container.ql-snow,\n.comment-input-custom .ql-container,\n.comment-input-custom .ql-editor {\n  border: none !important;\n  border-width: 0 !important;\n  border-style: none !important;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  outline: none !important;\n  background: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
